// extracted by mini-css-extract-plugin
export default {"heading":"a-version-number-dialog-module__heading","item":"a-version-number-dialog-module__item"};